import Player from './player';
import { APPLICATION_EVENT } from 'constants/events';

// Provides alternative player behavior in Editor contexts 
export default class Editor extends Player {
    constructor(options) {
        super({ ...options, editor: true });
    }
} 